import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import english from './languages/en.json';
import arabic from './languages/ar.json';
import { getLanguageFromStorage } from './languageUtils';

const resources = {
  en: {
    translation: english,
  },
  ar: {
    translation: arabic,
  },
};

const currentLang = getLanguageFromStorage();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: currentLang,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
